import { useEffect } from 'react';
import analytics from 'modules/analytics';
import { globalContext } from 'modules/analytics/constants';
import { useSplitClient } from './useSplitClient';
import { FeatureFlag, FFDefaults } from '../featureFlags.generated';

export function useSplitFlag<T = string>(flagName: FeatureFlag, castTo?: (arg1: string) => T): T;

export function useSplitFlag(flagName: FeatureFlag, castTo?: void): string;

/**
 * NOTE: uses Suspense, make sure to handle it accordingly
 */
// @ts-expect-error [EN-10263] - TS7006 - Parameter 'flagName' implicitly has an 'any' type. | TS7006 - Parameter 'castTo' implicitly has an 'any' type.
export function useSplitFlag(flagName, castTo) {
  const client = useSplitClient();
  // @ts-expect-error [EN-10263] - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Readonly<{ ANATOMIC_NAVIGATOR: "off"; AUTOLOAD_PRIORS: "on"; EDIT_CASE_PRIORITY: "on"; ENABLE_REPORTER_SUBMISSION: "on"; GSPS_ANNOTATIONS: "on"; HANGING_PROTOCOL_DESERIALIZATION: "legacy"; ... 61 more ...; ALLOW_MAMMO_SSC_FEATURES: "off"; }>'.
  const fallbackValue = FFDefaults[flagName];
  const flag = client != null ? client.getTreatment(flagName) : fallbackValue;

  const flagValue = flag === 'control' ? fallbackValue : flag;

  useEffect(() => {
    analytics.addContext(globalContext.workspace.featureFlag(flagName), flagValue);
  }, [flagName, flagValue]);

  return castTo ? castTo(flagValue) : flagValue;
}
